// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_int32 from "../../../../node_modules/rescript/lib/es6/caml_int32.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as ReactDOMStyle from "../../../../node_modules/@rescript/react/lib/es6_global/src/ReactDOMStyle.bs.js";
var Slot = {};
function string_of_value(value) {
  if (value) {
    return String(value._0);
  } else {
    return "auto";
  }
}
function add(a, b) {
  if (!a) {
    if (b) {
      return b._0;
    } else {
      return 99;
    }
  }
  var a$1 = a._0;
  if (b) {
    return a$1 + b._0 | 0;
  } else {
    return a$1;
  }
}
function toCSS(coord) {
  return ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp({}, "--smartnav-custom-grid-column-start", string_of_value(coord.x)), "--smartnav-custom-grid-column-end", "span " + string_of_value(coord.w)), "--smartnav-custom-grid-row-start", string_of_value(coord.y)), "--smartnav-custom-grid-row-end", "span " + string_of_value(coord.h));
}
var Coordinates = {
  string_of_value: string_of_value,
  add: add,
  toCSS: toCSS
};
function defaultPattern(param) {
  var height = param.height;
  var width = param.width;
  var skipRowsNum = height + 2 | 0;
  var adjustedOffset = param.offset > 1 ? param.offset : 1;
  var adjustedIndex = param.index + 1 | 0;
  var x = adjustedIndex % 2 === 0 ? Math.abs((param.columns - width | 0) + 1 | 0) : 0;
  var y = Math.imul(skipRowsNum, adjustedIndex) + (adjustedOffset - skipRowsNum | 0) | 0;
  return {
    x: /* Int */{
      _0: x
    },
    y: /* Int */{
      _0: y
    },
    w: /* Int */{
      _0: width
    },
    h: /* Int */{
      _0: height
    }
  };
}
var Pattern = {
  defaultPattern: defaultPattern
};
var initialValue = {
  renderSlots: undefined,
  slotCardWidth: 1,
  slotCardHeight: 1,
  slotCardOffset: 0,
  slotPattern: defaultPattern,
  slotAllowOverflow: false
};
var context = React.createContext(initialValue);
var ctxProvider = context.Provider;
function ListPageGridCustomSlots(Props) {
  var renderSlots = Props.renderSlots;
  var slotCardWidthOpt = Props.slotCardWidth;
  var slotCardHeightOpt = Props.slotCardHeight;
  var slotCardOffsetOpt = Props.slotCardOffset;
  var slotPatternOpt = Props.slotPattern;
  var slotAllowOverflowOpt = Props.slotAllowOverflow;
  var children = Props.children;
  var slotCardWidth = slotCardWidthOpt !== undefined ? slotCardWidthOpt : 1;
  var slotCardHeight = slotCardHeightOpt !== undefined ? slotCardHeightOpt : 1;
  var slotCardOffset = slotCardOffsetOpt !== undefined ? slotCardOffsetOpt : 2;
  var slotPattern = slotPatternOpt !== undefined ? slotPatternOpt : defaultPattern;
  var slotAllowOverflow = slotAllowOverflowOpt !== undefined ? slotAllowOverflowOpt : true;
  var value = {
    renderSlots: renderSlots,
    slotCardWidth: slotCardWidth,
    slotCardHeight: slotCardHeight,
    slotCardOffset: slotCardOffset,
    slotPattern: slotPattern,
    slotAllowOverflow: slotAllowOverflow
  };
  return React.createElement(ctxProvider, {
    value: value,
    children: children
  });
}
ListPageGridCustomSlots.displayName = "ListPageGridCustomSlots";
function use(columnNum, param) {
  var ctx = React.useContext(context);
  return React.useCallback(function (children) {
    var calculateCoordinates = function (index, render) {
      var modifiedSlotCardWidth = columnNum < ctx.slotCardWidth ? columnNum : ctx.slotCardWidth;
      var coordinates = Curry._1(ctx.slotPattern, {
        columns: columnNum,
        index: index,
        width: modifiedSlotCardWidth,
        height: ctx.slotCardHeight,
        offset: ctx.slotCardOffset
      });
      var childrenCount = children.length;
      var media = Belt_Option.getWithDefault(ctx.renderSlots, []);
      var mediaSize = Math.imul(ctx.slotCardHeight, modifiedSlotCardWidth);
      var previousMediaCount = Math.imul(Belt_Array.keepWithIndex(media, function (item, i) {
        return i < (index - 1 | 0);
      }).length, mediaSize);
      var itemCount = childrenCount + previousMediaCount | 0;
      var remainder = Caml_int32.mod_(itemCount, columnNum);
      var xLast = remainder === 0 && itemCount >= columnNum ? columnNum : remainder;
      var yLast = (Math.round(itemCount / columnNum) | 0) + 1 | 0;
      var canFit = yLast >= add(coordinates.y, coordinates.h) || xLast >= add(coordinates.x, coordinates.w) && yLast >= add(coordinates.y, coordinates.h);
      var coordinates$1 = canFit ? coordinates : {
        x: /* Auto */0,
        y: /* Auto */0,
        w: /* Auto */0,
        h: /* Auto */0
      };
      var isMultiColumnGrid = columnNum > 1;
      var isTooWide = modifiedSlotCardWidth >= columnNum;
      var fluid = canFit && isMultiColumnGrid && !isTooWide;
      var shape = canFit && fluid ? (/* Custom */{
        _0: ctx.slotCardWidth,
        _1: ctx.slotCardHeight
      }) : canFit ? (/* Custom */{
        _0: 0,
        _1: 0
      }) : undefined;
      return {
        render: render,
        style: toCSS(coordinates$1),
        fluid: fluid,
        canFit: canFit,
        shape: shape
      };
    };
    var renderSlot = function (index, intermediate) {
      if (intermediate.canFit || ctx.slotAllowOverflow) {
        return React.createElement("div", {
          key: "slot-card-" + String(index),
          className: CSS$Showside.prefix("custom-grid relative"),
          style: intermediate.style
        }, Curry._2(intermediate.render, intermediate.fluid, intermediate.shape));
      } else {
        return null;
      }
    };
    return Belt_Array.concat(children, Belt_Array.mapWithIndex(Belt_Array.mapWithIndex(Belt_Option.getWithDefault(ctx.renderSlots, []), calculateCoordinates), renderSlot));
  }, [ctx]);
}
var make = ListPageGridCustomSlots;
export { Slot, Coordinates, Pattern, initialValue, context, ctxProvider, make, use };
/* context Not a pure module */